const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) return;

    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        const scriptURL =
          (registration.active && registration.active.scriptURL) ||
          (registration.installing && registration.installing.scriptURL) ||
          (registration.waiting && registration.waiting.scriptURL) ||
          '';
        if (scriptURL && !scriptURL.endsWith('/service-worker.js')) {
          console.log('[SW Cleanup] Desregistrando SW viejo:', scriptURL);
          registration.unregister().then(() => {
            console.log('[SW Cleanup] SW viejo desregistrado:', scriptURL);
          });
        }
      });
    });

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
      } else {
        registerValidSW(swUrl, config);
      }

      navigator.serviceWorker.ready.then((registration) => {
        registration.update().catch(() => {});
      });
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      setInterval(() => {
        registration.update().then(() => {
          if (registration.waiting && navigator.serviceWorker.controller) {
            if (config && config.onUpdate) config.onUpdate(registration);
          }
        }).catch(() => {});
      }, 60000);

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          registration.update().then(() => {
            if (registration.waiting && navigator.serviceWorker.controller) {
              if (config && config.onUpdate) config.onUpdate(registration);
            }
          }).catch(() => {});
        }
      });

      window.addEventListener('online', () => {
        registration.update().then(() => {
          if (registration.waiting && navigator.serviceWorker.controller) {
            if (config && config.onUpdate) config.onUpdate(registration);
          }
        }).catch(() => {});
      });

      window.addEventListener('focus', () => {
        registration.update().then(() => {
          if (registration.waiting && navigator.serviceWorker.controller) {
            if (config && config.onUpdate) config.onUpdate(registration);
          }
        }).catch(() => {});
      });

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              if (config && config.onUpdate) config.onUpdate(registration);
            } else {
              if (config && config.onSuccess) config.onSuccess(registration);
            }
          }
        };
      };

      // FIX race condition: si ya hay un SW esperando cuando este codigo corre,
      // el evento updatefound ya se disparo antes de asignar el handler.
      // Disparamos onUpdate manualmente.
      if (registration.waiting && navigator.serviceWorker.controller) {
        if (config && config.onUpdate) {
          config.onUpdate(registration);
        }
      }
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}
